import { Box, Typography } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactPlayer from 'react-player'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

export interface RovBlobVideoPlayerProps {
  src: string
  thumbnailUrl?: string
  title?: string
}

export const RovBlobVideoPlayer: React.FC<RovBlobVideoPlayerProps> = ({ src, thumbnailUrl, title }) => {
  const { t } = useTranslation(['rov'])
  const theme = useTheme()
  const [hasError, setHasError] = useState(false)

  if (hasError) {
    return (
      <ErrorStateBox backgroundColor={getThemeColor(theme, MUIThemeColors.backgroundMain)}>
        <Typography variant="body2" color="text.secondary">
          {t('videoPlaybackError')}
        </Typography>
      </ErrorStateBox>
    )
  }

  return (
    <Box sx={{ aspectRatio: '16/9', width: '100%' }} aria-label={title}>
      <ReactPlayer
        src={src}
        poster={thumbnailUrl}
        controls
        width="100%"
        height="100%"
        onError={() => setHasError(true)}
      />
    </Box>
  )
}

const ErrorStateBox = styled(Box)<{ backgroundColor: string }>(({ backgroundColor }) => ({
  aspectRatio: '16/9',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor,
}))
